import React from "react";
import Logo from "./Logo";
import { useLang } from "../LangContext";

interface Props {
  onRetry: () => void;
}

export default function ServiceUnavailablePage({ onRetry }: Props) {
  const { t } = useLang();
  return (
    <main className="login-container">
      <div className="login-card" style={{ textAlign: "center" }}>
        <div className="login-brand">
          <Logo size={40} />
        </div>
        <h2>{t.serviceUnavailableHeading}</h2>
        <p style={{ color: "var(--text-secondary)", marginBottom: "var(--spacing-lg)" }}>
          {t.serviceUnavailableMessage}
        </p>
        <button className="button login-button" onClick={onRetry}>
          {t.serviceUnavailableRetry}
        </button>
      </div>
    </main>
  );
}
